import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InputFieldType } from '../../generated/graphql';

export const LABEL_MAP: Record<InputFieldType, string> = {
  PRODUCTION: 'SHARED_PRODUCT_PRODUCTION',
  POWER_FEED: 'POWER_FEED',
  DAY_AHEAD_COMMITTED_PRODUCTION: 'DAY_AHEAD_COMMITTED_PRODUCTION',
  AFRR_LOWER_LIMIT: 'SHARED_PRODUCT_AFRR_LOWER_LIMIT',
  AFRR_UPPER_LIMIT: 'SHARED_PRODUCT_AFRR_UPPER_LIMIT',
  AFRR_NEGATIVE: 'SHARED_PRODUCT_AFRR_NEGATIVE',
  AFRR_POSITIVE: 'SHARED_PRODUCT_AFRR_POSITIVE',
  MFRR_LOWER_LIMIT: 'SHARED_PRODUCT_MFRR_LOWER_LIMIT',
  MFRR_UPPER_LIMIT: 'SHARED_PRODUCT_MFRR_UPPER_LIMIT',
  MFRR_NEGATIVE: 'SHARED_PRODUCT_MFRR_NEGATIVE',
  MFRR_POSITIVE: 'SHARED_PRODUCT_MFRR_POSITIVE',
  FCR: 'SHARED_PRODUCT_FCR',
  FLEX_PLUS_LOWER_LIMIT: 'SHARED_PRODUCT_FLEX_PLUS_LOWER_LIMIT',
  FLEX_PLUS_UPPER_LIMIT: 'SHARED_PRODUCT_FLEX_PLUS_UPPER_LIMIT',
};

/**
 * Returns the label for a type of input field.
 */
export function useInputFieldLabel(type: InputFieldType): string;

/**
 * Returns the label for a type of input field.
 */
export function useInputFieldLabel(): (type: InputFieldType) => string;

export function useInputFieldLabel(type?: InputFieldType): ((type: InputFieldType) => string) | string {
  const [t] = useTranslation();
  const callback = useCallback((tp: InputFieldType) => t(LABEL_MAP[tp] ?? 'SHARED_UNKNOWN'), [t]);
  return type == null ? callback : callback(type);
}
